import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../../LicenceProfileHeader";
import LicenceProfileSubTabs from "../../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";
import LicenceHeader from "./LicenceHeader";
import LicenceDetails from "./LicenceDetails";
import BackToAuthorisationVersions from "./BackToAuthorisationVersions";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import FurtherInformation from "./FurtherInformation";
import LicenceApplicationTracker from "./LicenceApplicationTracker";
import { ILicensingActionGridFilterValueList } from "../../../../api/ILicensingAction";
import { ISubmissionsGridFilterValueList } from "../../../../api/ISubmission";
import { IChangeRequestsGridFilterValueList } from "../../../../api/IChangeRequests";
import { ILicenceTransfersGridFilterValueList } from "../../../../api/ILicenceTransfer";
import { MediaObj } from "../../../../hooks/useDetectScreenBreakpoints";

interface ApplicationLicenceProps {
  licence: IFullLicenceDetails;
  profileNo: string;
  licenceProfile: ILicenceProfile;
  licensingActionTypes: ILicensingActionGridFilterValueList;
  licensingActionStatuses: ILicensingActionGridFilterValueList;
  submissionTypes: ISubmissionsGridFilterValueList;
  submissionObjectorTypes: ISubmissionsGridFilterValueList;
  changeRequestsStatuses: IChangeRequestsGridFilterValueList;
  licenceTransfersStatuses: ILicenceTransfersGridFilterValueList;
  screenBreakpoints: MediaObj;
}

const ApplicationLicence = ({
  licence,
  profileNo,
  licenceProfile,
  licensingActionTypes,
  licensingActionStatuses,
  submissionTypes,
  submissionObjectorTypes,
  changeRequestsStatuses,
  licenceTransfersStatuses,
  screenBreakpoints,
}: ApplicationLicenceProps) => {
  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToAuthorisationVersions profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceHeader licence={licence} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceApplicationTracker
            licence={licence}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceDetails licence={licence} licenceProfile={licenceProfile} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FurtherInformation
            licence={licence}
            licenceProfile={licenceProfile}
            licensingActionStatuses={licensingActionStatuses}
            licensingActionTypes={licensingActionTypes}
            submissionTypes={submissionTypes}
            submissionObjectorTypes={submissionObjectorTypes}
            changeRequestsStatuses={changeRequestsStatuses}
            licenceTransfersStatuses={licenceTransfersStatuses}
            screenBreakpoints={screenBreakpoints}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} licence={licence} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default ApplicationLicence;
